import {createApp} from 'vue'
import App from './App.vue'
import './main.css'
import 'animate.css';
import {createRouter, createWebHistory} from 'vue-router'
import Home from "@/views/Home.vue";
import Fasciass from "@/views/Fascias.vue";

const routes = [
    {path: '/', component: Home},
    {path: '/fascias', component: Fasciass}
]

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to) {
        if (to.hash) {
            return {el: to.hash, behavior: 'smooth'}
        }
        return {top: 0, behavior: 'smooth'}
    },
    routes
})

const Vue = createApp(App)
Vue.use(router)
Vue.mount('#app')
